module.exports = __webpack_public_path__ + "static/media/quality.3f5ff57f.svg";